module.exports = "<table class=\"myDeliverySaver-payments\">\r\n    <tr ng-repeat=\"payment in $ctrl.payments | filter: { Status: 'Success' } | orderBy: 'PaymentDate':true\">\r\n        <td>{{payment.PaymentDate | date: \"dd/MM/yy\"}}</td>\r\n        <td>{{payment.Amount | currency}}</td>\r\n    </tr>\r\n</table>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/deliverysaver/mydeliverysaver/payments/my-delivery-saver-payments.component.html
// module id = 391
// module chunks = 0 9